import { States } from '@truepill/tpos-types'

const states = Object.values(States).sort()

export const getStatesExcluding = (mStates: States[]): States[] => states.filter(s => !mStates.includes(s))

const STATE_TO_ZONE_MAP: Record<States, number> = {
  AK: 1,
  ID: 1,
  MT: 1,
  ND: 1,
  NE: 1,
  OR: 1,
  SD: 1,
  WA: 1,
  WY: 1,
  AZ: 2,
  CA: 2,
  CO: 2,
  HI: 2,
  KS: 2,
  NM: 2,
  NV: 2,
  OK: 2,
  TX: 2,
  UT: 2,
  CT: 3,
  DC: 3,
  DE: 3,
  IA: 3,
  IL: 3,
  IN: 3,
  MA: 3,
  MD: 3,
  ME: 3,
  MI: 3,
  MN: 3,
  NH: 3,
  NJ: 3,
  NY: 3,
  OH: 3,
  PA: 3,
  RI: 3,
  VT: 3,
  WI: 3,
  AL: 4,
  AR: 4,
  FL: 4,
  GA: 4,
  KY: 4,
  LA: 4,
  MO: 4,
  MS: 4,
  NC: 4,
  PR: 4,
  SC: 4,
  TN: 4,
  VA: 4,
  WV: 4,
}

const WEATHER_ZONES: number[] = Array.from(new Set(Object.values(STATE_TO_ZONE_MAP)))
export const getAllWeatherZones = (): number[] => WEATHER_ZONES

const ZONE_TO_STATE_MAP: Map<number, States[]> = new Map()
Object.keys(STATE_TO_ZONE_MAP).forEach(state => {
  const zone = STATE_TO_ZONE_MAP[state as States]
  if (!ZONE_TO_STATE_MAP.has(zone)) {
    ZONE_TO_STATE_MAP.set(zone, [])
  }
  ZONE_TO_STATE_MAP.get(zone)?.push(state as States)
})

export const getWeatherZoneFromState = (state: string): number | null => {
  const normalizedState = state.trim().toUpperCase()
  return STATE_TO_ZONE_MAP[normalizedState as States] ?? null
}

export const getStatesInWeatherZone = (zone: number): States[] => {
  return ZONE_TO_STATE_MAP.get(zone) || []
}
export default states
